export const LOADER_DETAIL_TRAINING             =    'LOADER_DETAIL_TRAINING';
export const GET_DETAIL_TRAINING                =    'GET_DETAIL_TRAINING';
export const DETAIL_TRAINING_FAIL               =    'DETAIL_TRAINING_FAIL';
export const SAVE_LOADER_DETAIL_TRAINING        =    'SAVE_LOADER_DETAIL_TRAINING';
export const FORM_DETAIL_TRAINING_FAIL          =    'FORM_DETAIL_TRAINING_FAIL';

